var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { class: _vm.size, attrs: { id: "overrides-msg" } }, [
      _c(
        "div",
        { staticClass: "card" },
        [
          _c(
            "b-row",
            { staticClass: "justify-content-center p-4" },
            [
              _vm.page != "coBrokering"
                ? _c("b-col", { attrs: { cols: "12", md: "9" } }, [
                    _c(
                      "h5",
                      { staticClass: "override-title font-weight-bold" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t("settings.turnOnBrokerageOverridesFor")
                            ) +
                            "\n            "
                        ),
                        _c(
                          "span",
                          { class: { "text-uppercase": _vm.page === "faq" } },
                          [_vm._v(_vm._s(_vm.formatPageName(_vm.page)))]
                        ),
                        _vm._v("?\n          "),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "m-0 d-none d-sm-block" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("settings.changesMadeInThisPageWillAplyTo")
                          ) +
                          "\n          "
                      ),
                    ]),
                  ])
                : _c("b-col", { attrs: { cols: "12", md: "9" } }, [
                    _c(
                      "h5",
                      { staticClass: "override-title font-weight-bold" },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "settings.turnOnBrokerageOverridesForCoBrokering"
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "m-0 d-none d-sm-block" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t("settings.settingToggleToYesForCoBrokering")
                          ) +
                          "\n          "
                      ),
                    ]),
                  ]),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass:
                    "my-auto pretty-custom d-flex flex-row d-sm-block justify-content-end text-center",
                  attrs: { cols: "12", md: "3", lg: "3" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "pretty p-bigger p-switch p-fill" },
                    [
                      _c("label", { staticClass: "text-gray label-before" }, [
                        _vm._v(_vm._s(_vm.$t("global.words.no"))),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { id: "switch", type: "checkbox" },
                        domProps: { checked: _vm.currentOverrideChecked },
                        on: { change: _vm.handleChangeOverride },
                      }),
                      _vm._v(" "),
                      _c(
                        "label",
                        { staticClass: "d-none", attrs: { for: "switch" } },
                        [_vm._v(_vm._s(_vm.$t("global.words.switch")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "state" }, [
                        _c("label", { staticClass: "regular" }, [
                          _vm._v(_vm._s(_vm.$t("global.words.yes"))),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }